import ImageAtom from "@components/atoms/Image";
import styles from "./SubTab.module.scss";
import Button from "@components/atoms/Button";
import assetLoader from "@utils/internalImageLoder";

interface SubTabProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const SubTab = ({ id, label, isActive, onClick }: SubTabProps) => {
  return (
    <Button
      onClick={onClick}
      className={`${styles["sub-tab"]} ${
        isActive ? styles["sub-tab--active"] : styles["sub-tab--inactive"]
      }`}
    >
      {label}
      {isActive && (
        <ImageAtom
          src={`${assetLoader()}/cross.svg`}
          alt="Close"
          width={16}
          height={16}
          className={styles["sub-tab__close-icon"]}
        />
      )}
    </Button>
  );
};
